<div class="grid  align-items-center py-3">
    <div class="col-3 py-3">
      <div class="custom-tab">
        <span class="tab-label">
          {{ selectedCategory ? selectedCategory : 'All' }}
        </span>
      </div>        
    </div>

    <!-- Dropdown + Toggle (col-9) -->
    <div class="col-9 py-3 flex justify-content-end items-center gap-2">
      <p-dropdown [options]="categories"  [(ngModel)]="selectedCategory" optionValue="value" placeholder="Select Category"
        (onChange)="onCategoryChange($event)" styleClass="w-full col-12" class="dropdown-sm full-width"
        [showClear]="true">
      </p-dropdown>
    </div>
    
  </div>
  <div class="flex justify-content-around align-items-center gap-4 pr-3 pl-0 pb-3">
    <!-- Mark All as Read Button -->
    <button pButton type="button" class="markAllAsRead" label="Mark all as read" style="padding: 5px 10px;" size="small"  class="p-button-sm" (click)="markAllAsRead()"></button>

  
    <!-- Only Unread Switch and Label wrapper -->
    <div class="flex align-items-center gap-2">
      <p-inputSwitch id="onlyUnread" [(ngModel)]="onlyShowUnread" (onChange)="applyFilters()"></p-inputSwitch>
      <label for="onlyUnread" class="text-sm font-medium text-gray-700 select-none mb-0">Only show unread</label>
    </div>
  </div>
  
  
    <div class="notification-list custom-scroll">
      <ng-container *ngIf="notifications.length > 0; else noNotifications">
        <div *ngFor="let notif of notifications" class="notification-card border-b pb-3 mb-3 "  >
          <div class="flex gap-3">
            <div class="avatar">{{ getInitials(notif?.title) }}</div>
            <div class="content w-full">
              <div class="flex justify-between items-start">
                <p class="message">{{ notif?.message }}</p>
                <span *ngIf="!notif?.read" class="dot"></span>
              </div>
              <div class="flex align-items-center justify-content-between mt-2 text-xs text-gray-500">
                <span class="flex align-content-center white-space-nowrap pr-3">
                  {{ notif['displayTimeAgo'] }}
                </span>
                <span class="tag" [ngClass]="getTagClass(notif?.title)">
                  {{ notif?.title }}
                </span>
                <span>
                  <div class="flex items-center gap-3">    
                    <!-- Mark as Read Icon (if unread) -->
                    <i
                      *ngIf="!notif?.read"
                      class="pi pi-check-circle text-green-600 hover:text-green-700 cursor-pointer"
                      [pTooltip]="'Mark as Read'"
                      tooltipPosition="left"
                      (click)="markAsRead(notif, $event)"
                    ></i>
        
                    <!-- Redirection Icon -->
                    <i
                      class="pi pi-arrow-right text-blue-600 hover:text-blue-700 cursor-pointer"
                      [pTooltip]="'Go to Page'"
                      tooltipPosition="left"
                      (click)="redirectToPage(notif)"
                    ></i>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    
      <!-- ✅ Empty State -->
      <ng-template #noNotifications>
        <div class="flex flex-column align-items-center justify-content-center text-gray-500 text-sm p-4" style="height: 200px;">
          <i class="pi pi-bell-off text-4xl mb-3"></i>
          <span>No Notifications Received</span>
        </div>
      </ng-template>
    </div>
    
      